import { bootstrap } from "./app/bootstrap";

async function main() {
  try {
    const controller = await bootstrap();

    console.log("Bottle Packing Puzzle initialized successfully");
    console.log(`Current level: ${controller.getCurrentLevel()}`);

    window.addEventListener("beforeunload", () => {
      controller.destroy();
    });
  } catch (error) {
    console.error("Failed to initialize game:", error);
  }
}

main();
